import React from 'react';
import { Video, Utensils, TrendingUp, Lightbulb, CheckCircle } from 'lucide-react';

const features = [
  {
    icon: Video,
    title: 'Treningsvideoer i høy kvalitet',
    description:
      'Følg med på trinnvise treningsøkter ledet av sertifiserte trenere. Programmer tilpasset alle nivåer – fra nybegynner til avansert.',
    points: ['Daglige nye videoer', 'Alle treningsformer', 'Steg-for-steg instruksjon'],
  },
  {
    icon: Utensils,
    title: 'Sunn oppskriftsamling',
    description:
      'Oppdag hundrevis av sunne og smakfulle oppskrifter som hjelper deg å holde deg på sporet med treningsmålene dine.',
    points: ['Næringsberegnet', 'Tilpasset ditt mål', 'Rask og enkel matlaging'],
  },
  {
    icon: TrendingUp,
    title: 'Treningsfremdriftssporing',
    description:
      'Overvåk fremgangen din med intelligente sporingsverktøy. Se resultater, sett nye mål og hold motivasjonen oppe.',
    points: ['Visuell fremgangslogg', 'Ukes- og månedsoversikt', 'Personlige mål'],
  },
  {
    icon: Lightbulb,
    title: 'Daglige treningstips',
    description:
      'Få ekspertråd om teknikk, utholdenhet og mental helse – direkte i appen. Alltid oppdatert, alltid relevant.',
    points: ['Trenertips fra eksperter', 'Mental styrketrening', 'Skadeforebygging'],
  },
];

const HowItWorks = () => {
  return (
    <section id="funksjoner" className="py-24 bg-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-light text-sm font-semibold uppercase tracking-widest">Funksjoner</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-black text-white font-heading">
            Alt du trenger for å{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
              lykkes
            </span>
          </h2>
          <p className="mt-4 text-lg text-slate-400 max-w-2xl mx-auto">
            Workout ON er bygget for folk som er seriøse med treningen sin. Kraftige verktøy,
            ekspertinnhold og ubegrenset motivasjon – samlet på ett sted.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-card-dark border border-border-dark rounded-2xl p-8 hover:border-primary/40 transition-all duration-300 group"
            >
              <div className="flex items-start space-x-5">
                <div className="w-14 h-14 bg-primary/10 border border-primary/20 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                  <feature.icon className="w-7 h-7 text-primary-light" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-3 font-heading">{feature.title}</h3>
                  <p className="text-slate-400 leading-relaxed mb-5">{feature.description}</p>
                  <ul className="space-y-2">
                    {feature.points.map((point, i) => (
                      <li key={i} className="flex items-center space-x-2 text-sm text-slate-300">
                        <CheckCircle className="w-4 h-4 text-primary shrink-0" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
